module.exports = __webpack_public_path__ + "img/image36.c0fbcfef.png";